<template>
  
  <section class="overflow myModal"> 


    <!-- //TITLE MOBILE -->
      <div class="mobile"  :class="{isMobile:isMobile}">
        <div class="link">
          <button class="bt btn-back" @click="goBack()">
            <font-awesome-icon :icon="['far', 'times']"/>
          </button>
          <h2>{{general.messagerieSelect}}</h2>
        </div>
        <div class="sep"></div>
      </div>
    <!-- //TITLE MOBILE -->



    <!-- CONTENT -->
    <div class="block__messagerie content__messagerie content__messagerie-contact">
      <ion-searchbar ref="searchBar" @ionChange="eventSearch" value="" :placeholder="general.searchPlaceholder" ></ion-searchbar>

      <!-- <Stack height="0.25rem"></Stack> -->
      <Stack></Stack>

      <!-- TITLE -->
      <h2 class="blue">{{general.messagerieSelect}}</h2>
      <!-- TITLE -->

      <Stack></Stack>

      <!-- SELECT LIST -->
      <div class="select__wrapper">
        <CustomSelect
          :options="options"
          :default.sync="optionsDefault"
          class="select"
          @input="displayToKey($event)"
          ref="customSelect"
        />      
      </div>      
      <!-- SELECT LIST -->

      <Stack></Stack>


      <!-- CONTAINER CHECKBOXS -->
      <b-form-group>

        <!-- CHECKBOX ALL -->
        <b-form-checkbox
            v-model="allSelected"
            :indeterminate="indeterminate"
            aria-describedby="filteredList"
            aria-controls="filteredList"
            @change="toggleAll"
          >
            {{general.messagerieAll}}
        </b-form-checkbox>
        <!-- CHECKBOX ALL -->

        <Stack></Stack>

          <!-- CHECKBOX LIST -->
          <PuSkeleton :loading="isLoading" :count="10">    
          <b-form-checkbox-group v-for="(commercial, i) in filteredList" :key="`${i}-${commercial.id}`">
            <b-list-group-item  >
                <b-form-checkbox
                    v-model="selected"
                    :id="commercial.id"
                    :name="commercial.fullName"
                    :value="commercial.fullName" 
                    :indeterminate.sync="indeterminate"    
                  >
                    {{commercial.fullName}}
                    <div class="right" :class="commercial.class">
                      {{commercial.number}}
                    </div>
                  </b-form-checkbox>
            </b-list-group-item>
          </b-form-checkbox-group>
          </PuSkeleton>
          <!-- CHECKBOX LIST -->


        </b-form-group>
      <!-- CONTAINER CHECKBOXS -->

      <!-- SHOW SELECTED IN MOBILE -->
      <footer v-if="selected.length">
        <div class="flex">
            <p>{{listSelected}}</p>
            <button class="btn btn-blue" v-on:click="validated">{{general.messagerieValidate}}</button>
        </div>
      </footer>
      <!-- SHOW SELECTED IN MOBILE -->

    </div>
    <!-- CONTENT-->
  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import Stack from '../../../module/stack/Stack'
import ApiService from '../../../../services/ApiService';
import ApiAuthenticationService from '../../../../services/ApiAuthenticationService';
import CustomSelect from '../../../module/select/CustomSelect';


export default {
  name:"challengesMessageriesContact",
    components:{ 
      Stack,
      CustomSelect
    }, 
    props:{ 
      noTitle:Boolean,
    },
    computed: {
      ...mapGetters([
        'getBlog',
        'getGeneral',
        'getChallengeSelected',
        'getIsMobile'
      ]),  
      fullnameList() {
        return this.filteredList.map(value => {
          return value.fullName;
      })},

      filteredList() {
        return this.commercials.filter(commercial => {
          return commercial.fullName.toLowerCase().includes(this.search.toLowerCase())
      })},
      allEmail() {
        let listeComplet = this.commercials.filter(person => this.selected.includes(person.fullName));
        return listeComplet;
      },           
    },
    data () {
      return {
        form: {
          criteria: '',
        },  
        commercials: [],
        status: 'not_selected',
        general:"",
        search: '',
        //
        selected: [],
        listSelected:[],
        allSelected: false,
        indeterminate: true,

        selection:null,
        isLoading:true,
        isMobile:false,   
        //
        listCommercials:'',
        //
        destSelect:'',  
        optionsDefault:'', // Default text for select category       
        options: [], //options array form custom select
      }
    },
    created (){
      this.general = this.getGeneral;
      this.isMobile = this.getIsMobile;
      this.optionsDefault = 'Choisir un type';
      //
      this.getData();   
    },    
    methods : {
      async getData(){
        this.isLoading = true;
        if(this.getChallengeSelected != '' && this.getChallengeSelected != null){
          await ApiService.getMessagingApi().getTypeList(this.getChallengeSelected,ApiAuthenticationService.getCurrentUser().id).then((data) => {
            this.destSelect = data.data;
            this.destSelect.map(element => {this.options.push(element.name)});
          });
        }
        this.isLoading = false;
      },



      //Event when change category select
      async displayToKey ($e){
        //AS SOON AS A LIST IS SELECTED -> SAVE THE CURRENT ID IN THE STORE
        if ($e != this.optionsDefault){
          let target = this.destSelect[this.options.indexOf($e)];
          this.isLoading = true;
          this.$refs.searchBar.value = '';
          this.listCommercials = await ApiService.getMessagingApi().getDestList(this.getChallengeSelected,ApiAuthenticationService.getCurrentUser().id,null,target.id);
          this.listCommercials = this.listCommercials.data;
          this.commercials = this.listCommercials;
          this.isLoading = false;
        }
        //
      },      
      
      
      async eventSearch (event){
          this.isLoading = true;
          this.listCommercials = await ApiService.getMessagingApi().getDestList(this.getChallengeSelected,ApiAuthenticationService.getCurrentUser().id,event.target.value,null);
          this.listCommercials = this.listCommercials.data;
          this.commercials = this.listCommercials;
          this.optionsDefault = this.general.challengesListConcoursDefault;
          this.$refs.customSelect.reset();
          this.isLoading = false;        
      },      


      goBack() {
        this.$store.dispatch('goBack')
        if(!this.isMobile){
          this.$router.push({name: "challenges-messagerie"});  
        }else{
          this.$router.push({name: "mobile", params: { subcat: 6 } });
          setTimeout(()=>{
            this.$store.dispatch('showFooter',true);
          },200)          
        }
      },    


      swipeRightHandler () {
          this.goBack();
      },  



      validated : function () {
        // MOBILE : ENREGISTRER DANS LE STORE LA LISTE POUR QUE LE PARENT PUISSE LES RÉCUPÉRERS
        this.$store.dispatch('setReceiver',this.allEmail);
        this.isMobile ? this.goBack() : '';        
      },


      toggleAll(checked) {
        this.selected = checked ? this.fullnameList.slice() : []
      },


      cancel(){
        this.selected = [];
      } 
        
    },
    watch : {
      'selected' : function(){
        this.listSelected = this.selected.toString();
        this.listSelected = this.listSelected.replace(',',', ');
        this.listSelected.length > 20 ? this.listSelected = this.listSelected.substring(0,20) + '...': '';
        this.$emit('receiver',this.selected);
      },
      'getChallengeSelected' : function (){
        this.getData();      
      },
      getIsMobile(){
        this.isMobile = this.getIsMobile;
      }
    }
};
</script>
